var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderElementComponent"},[_c('p',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm.date)+" ")]),_c('p',{staticClass:"orderText"},[_vm._v(" "+_vm._s(_vm.getOrders())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }